import { RouteObject } from 'react-router-dom'
import { ROUTES } from '.'
import { Admin, TableEtapas, TableGroups, TablePerfiles, TableSectoresComerciales, TableUsers } from '../pages'
import { SafetyRoute } from 'src/components/security'
import { AppSecObjects, SecurityComponents } from 'src/types/security'
import TablaEventos from '../pages/eventos/components/TablaEventos'

export const adminRouter: RouteObject[] = [
    {
        path: ROUTES.PANEL,
        element: (
            <SafetyRoute componentName={SecurityComponents.AppRutas} objectName={AppSecObjects.RutaPanelAdmin}>
                <Admin />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.USUARIOS}`,
        element: (
            <SafetyRoute componentName={SecurityComponents.AppRutas} objectName={AppSecObjects.RutaAdminUsuarios}>
                <TableUsers />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.GRUPOS}`,
        element: (
            <SafetyRoute componentName={SecurityComponents.AppRutas} objectName={AppSecObjects.RutaAdminGrupos}>
                <TableGroups />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.SECTORES_COMERCIALES}`,
        element: (
            <SafetyRoute
                componentName={SecurityComponents.AppRutas}
                objectName={AppSecObjects.RutaAdminSectoresComerciales}
            >
                <TableSectoresComerciales />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.ETAPAS}`,
        element: (
            <SafetyRoute componentName={SecurityComponents.AppRutas} objectName={AppSecObjects.RutaAdminEtapas}>
                <TableEtapas />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.PERFILES}`,
        element: (
            <SafetyRoute componentName={SecurityComponents.AppRutas} objectName={AppSecObjects.RutaAdminPerfiles}>
                <TablePerfiles />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.EVENTOS}`,
        element: (
            <SafetyRoute componentName={SecurityComponents.AppRutas} objectName={AppSecObjects.RutaAdminEventos}>
                <TablaEventos />
            </SafetyRoute>
        )
    }
]
